import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const OTPModalUI = ({
  OTPModal,
  setOTPModal,
  resendOTP,
  OTPField,
  setOTPField,
  inputRefs,
  handleChangeOTP,
  counter,
  setCounter,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (OTPModal === 1 || OTPModal === 2 || OTPModal === true) {
      if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }
    }
  }, [OTPModal === 1 || OTPModal === 2 || OTPModal === true]);

  useEffect(() => {
    let intervalId;
    if (counter > 0) {
      intervalId = setInterval(() => {
        setCounter(counter - 1);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [counter]);

  const handleKeyDownOTP = (index, e) => {
    if (
      e.key === "Backspace" &&
      !OTPField[index] &&
      index > 0 &&
      inputRefs.current[index - 1]
    ) {
      inputRefs.current[index - 1].focus();
    }
  };

  return (
    <Modal show={OTPModal === 1 || OTPModal === 2 || OTPModal === true}>
      <Modal.Header closeButton>
        <Modal.Title className="otp-title">{t("Please Enter your OTP Here")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6>
          {t(
            "Please check your email inbox for the one-time code. Once you've received it, enter it in the OTP box to proceed."
          )}
        </h6>
        <div className="text-center otp-popup" style={{ marginTop: "14px" }}>
          {OTPField?.map((item, index) => (
            <input
              key={index}
              type="text"
              value={item}
              ref={(input) => (inputRefs.current[index] = input)}
              onChange={(e) => handleChangeOTP(index, e)}
              onKeyDown={(e) => handleKeyDownOTP(index, e)}
              style={{
                width: "50px",
                margin: "5px",
                height: "50px",
                textAlign: "center",
                fontWeight: "bold",
              }}
            />
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary"
          onClick={() => {
            setOTPModal(0);
            setOTPField(new Array(4).fill(""));
            setCounter(300);
          }}
        >
          {t("Close")}
        </Button>
        <Button
          variant="outline-primary"
          onClick={() => {
            if (counter === 0) {
              setCounter(300);
              resendOTP();
            }
          }}
          disabled={counter > 0}
        >
          {counter > 0
            ? t("Resend in") + " " + `${counter}` + " " + t("seconds")
            : t("Resend")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
